import * as React from "react";

import type { DesignaliProps } from "../../types";

export const University = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <circle cx="12" cy="10" r="1" />
        <path d="M22 20V8h-4l-6-4-6 4H2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2" />
        <path d="M6 17v.01" />
        <path d="M6 13v.01" />
        <path d="M18 17v.01" />
        <path d="M18 13v.01" />
        <path d="M14 22v-5a2 2 0 0 0-2-2a2 2 0 0 0-2 2v5" />
      </svg>
    );
  },
);

export default University;
